import { Alert, Box, Button, Card, CardContent, Typography } from '@mui/material';
import { useGlobalConfig } from 'context/GlobalContext';
import { ROUTE_TREE } from 'routes/AppRoutes';

export const IngestionConfigsPage = () => {
  const { rc } = useGlobalConfig();

  return (
    <Box sx={{ p: { xs: 2, md: 4 } }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, mb: 2 }}>
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            Ingestion Configurations
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Configure ingestion settings for the selected project.
          </Typography>
        </Box>
        <Button variant="outlined" onClick={() => rc.uiRouter.navigate(ROUTE_TREE.PROJECT.DETAILS)}>
          Back to Project Details
        </Button>
      </Box>

      <Card sx={{ borderRadius: 2, boxShadow: 1 }}>
        <CardContent>
          <Alert severity="info">
            UI is being implemented. Next step is to surface ingestion-related configs and validations for this project.
          </Alert>
        </CardContent>
      </Card>
    </Box>
  );
};

